<template>
  <div>
    <b-form-row>
      <h5 class="col-12 text-primary font-weight-bold pb-2">
        Water Crossing Reminders
      </h5>
      <b-col v-if="objectAndPropsNotEmpty(reminders)">
        <b-alert v-if="reminders.noLUPCZone && !isLUPCTown" variant="danger" show>
          You have indicated that you plan to install water crossings. This
          activity is allowed without a permit but
          <a :href="links.chapter27Rules" target="_blank" rel="noopener noreferrer">Chapter 27</a>
          standards must be followed.
        </b-alert>
        <b-alert v-if="reminders.permanentInOrganizedTown" variant="danger" show>
          One or more permanent water crossings are proposed in an organized town, therefore a
          Permit-by-Rule (PBR) is required to be submitted to the Maine Forest Service and approved
          prior to installation.
        </b-alert>
        <b-alert v-if="reminders.temporaryInSWSTown" variant="danger" show>
          You have indicated you will construct water crossings in a Statewide Standards town and as
          such, all must be constructed, maintained and closed out in accordance with the
          requirements of Maine Forest Service
          <a :href="links.chapter21Rules" target="_blank" rel="noopener noreferrer">
            Chapter 21</a> rules.
        </b-alert>
        <b-alert v-if="reminders.permanentInSWSTown" variant="danger" show>
          <em><strong>WARNING:</strong></em> You have indicated plans to install one or more permanent water crossings. 
          Depending on the crossing design and the type of water resource involved, you must obtain either a Permit by 
          Rule or a full permit <i>before</i> beginning installation.<br/><br/>
          For Permit by Rule crossings installed between <strong>October 2 and July 15</strong>, a <strong>20-day 
          waiting period</strong> applies, and you may not install the water crossings until approved by the MFS in writing.
          <br/><br/>
          For permit forms and additional information, contact the Maine Forest Service or visit:<br/>
          <a href="https://www.maine.gov/dacf/mfs/policy_management/permitting/index.html" target="_blank">
          https://www.maine.gov/dacf/mfs/policy_management/permitting/index.html</a>          
        </b-alert>
        <b-alert
          v-if="arrayNotEmpty(reminders.skidTrailNoPermitRequiredSubdistricts)"
          variant="danger"
          show
        >
          <span>You have indicated that you plan to install skid trail stream crossings in {{reminders.skidTrailNoPermitRequiredSubdistricts.length === 1 ? 'a' : 'the'}} {{joinList(reminders.skidTrailNoPermitRequiredSubdistricts)}} protection {{pluralizeMultiple('subdistrict', reminders.skidTrailNoPermitRequiredSubdistricts)}}.</span>&nbsp;
          <span>This activity is allowed without a permit, but <a :href="links.chapter27Rules" target="_blank" rel="noopener noreferrer">Chapter 27</a> standards must be followed.</span>
        </b-alert>
        <b-alert
          v-if="arrayNotEmpty(reminders.skidTrailFOPermitMaybeRequiredSubdistricts)"
          variant="danger"
          show
        >
          <span>You have indicated that you plan to install skid trail stream crossings in {{reminders.skidTrailFOPermitMaybeRequiredSubdistricts.length === 1 ? 'a' : 'the'}} {{joinList(reminders.skidTrailFOPermitMaybeRequiredSubdistricts)}} protection {{pluralizeMultiple('subdistrict', reminders.skidTrailFOPermitMaybeRequiredSubdistricts)}}.</span>&nbsp;
          <span>A <a :href="links.operationsPermit" target="_blank" rel="noopener noreferrer">Forest Operations Permit</a> may be required, depending on your specific activity and location.</span>&nbsp;
          <span>Please contact the Maine Forest Service for more information.</span>          
        </b-alert>
        <b-alert
          v-if="arrayNotEmpty(reminders.skidTrailPermitRequiredSubdistricts)"
          variant="danger"
          show
        >
          <span>You have indicated that you plan to install skid trail stream crossings in {{reminders.skidTrailPermitRequiredSubdistricts.length === 1 ? 'a' : 'the'}} {{joinList(reminders.skidTrailPermitRequiredSubdistricts)}} protection {{pluralizeMultiple('subdistrict', reminders.skidTrailPermitRequiredSubdistricts)}}.</span>&nbsp;
          <span>A <a :href="links.operationsPermit" target="_blank" rel="noopener noreferrer">Forest Operations Permit</a> must be submitted to the Maine Forest Service and approved, prior to the start of your planned activity.</span>&nbsp;
        </b-alert>
        <b-alert
          v-if="arrayNotEmpty(reminders.skidTrailLUPCPermitMaybeRequiredSubdistricts)"
          variant="danger"
          show
        >
          <span>You have indicated that you plan to install skid trail stream crossings in {{reminders.skidTrailLUPCPermitMaybeRequiredSubdistricts.length === 1 ? 'a' : 'the'}} {{joinList(reminders.skidTrailLUPCPermitMaybeRequiredSubdistricts)}} protection {{pluralizeMultiple('subdistrict', reminders.skidTrailLUPCPermitMaybeRequiredSubdistricts)}}.</span>&nbsp;
          <span>A permit issued by the <a :href="links.lupc" target="_blank" rel="noopener noreferrer"> Maine Land Use Planning Commission</a> may be required.</span>&nbsp;
          <span>Please contact LUPC for more information.</span>
        </b-alert>
        <b-alert v-if="reminders.skidTrailPFW" variant="danger" show>
          <span>You have indicated that you plan to install skid trail stream crossings in a P-FW protection subdistrict.</span>&nbsp;
          <span>A consultation with <a :href="links.mdifw" target="_blank" rel="noopener noreferrer">Maine Inland Fisheries and Wildlife</a> (IF&amp;W) is required before you begin your activity.</span>&nbsp;
          <span>Please contact IF&W for more information.</span>&nbsp;
        </b-alert>
        <b-alert
          v-if="arrayNotEmpty(reminders.roadNoPermitRequiredSubdistricts)"
          variant="danger"
          show
        >
          You have indicated that you plan to install road stream crossings in {{reminders.roadNoPermitRequiredSubdistricts.length === 1 ? 'a' : 'the'}} {{joinList(reminders.roadNoPermitRequiredSubdistricts)}} protection
          {{pluralizeMultiple('subdistrict', reminders.roadNoPermitRequiredSubdistricts)}}. This
          activity is allowed without a permit, but
          <a :href="links.chapter27Rules" target="_blank" rel="noopener noreferrer">Chapter 27</a>
          standards must be followed.
        </b-alert>
        <b-alert
          v-if="arrayNotEmpty(reminders.roadFOPermitMaybeRequiredSubdistricts)"
          variant="danger"
          show
        >
          You have indicated that you plan to install road stream crossings in {{reminders.roadFOPermitMaybeRequiredSubdistricts.length === 1 ? 'a' : 'the'}} {{joinList(reminders.roadFOPermitMaybeRequiredSubdistricts)}} protection
          {{pluralizeMultiple('subdistrict', reminders.roadFOPermitMaybeRequiredSubdistricts)}}.
          A <a :href="links.operationsPermit" target="_blank" rel="noopener noreferrer">
            Forest Operations Permit</a> may be required, depending on your specific activity and
          location. Please contact the Maine Forest Service for more information.
        </b-alert>
        <b-alert
          v-if="arrayNotEmpty(reminders.roadPermitRequiredSubdistricts)"
          variant="danger"
          show
        >
          You have indicated that you plan to install road stream crossings in {{reminders.roadPermitRequiredSubdistricts.length === 1 ? 'a' : 'the'}} {{joinList(reminders.roadPermitRequiredSubdistricts)}} protection
          {{pluralizeMultiple('subdistrict', reminders.roadPermitRequiredSubdistricts)}}.
          A <a :href="links.operationsPermit" target="_blank" rel="noopener noreferrer">
            Forest Operations Permit</a> must be submitted to the Maine Forest Service and approved,
          prior to the start of your planned activity.
        </b-alert>
        <b-alert
          v-if="arrayNotEmpty(reminders.roadLUPCPermitMaybeRequiredSubdistricts)"
          variant="danger"
          show
        >
          You have indicated that you plan to install road stream crossings in {{reminders.roadLUPCPermitMaybeRequiredSubdistricts.length === 1 ? 'a' : 'the'}} {{joinList(reminders.roadLUPCPermitMaybeRequiredSubdistricts)}} protection
          {{pluralizeMultiple('subdistrict', reminders.roadLUPCPermitMaybeRequiredSubdistricts)}}. A
          permit issued by the <a :href="links.lupc" target="_blank" rel="noopener noreferrer">
            Maine Land Use Planning Commission</a> may be required. Please contact LUPC for
          more information.
        </b-alert>
        <b-alert v-if="reminders.roadPFW" variant="danger" show>
          <span>You have indicated that you plan to install road stream crossings in a P-FW protection subdistrict.</span>&nbsp;
          <span>A consultation with <a :href="links.mdifw" target="_blank" rel="noopener noreferrer">Maine Inland Fisheries and Wildlife</a> (IF&amp;W) is required before you begin your activity.</span>&nbsp;
          <span>Please contact IF&W for more information.</span>
        </b-alert>
      </b-col>
      <b-col v-else>
        There are no important reminders.
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Utilities from '@/mixins/Utilities';

export default {
  name: 'WaterCrossingReminders',
  mixins: [Utilities],
  computed: {
    ...mapState('Configuration', {
      links: state => state.links,
    }),
    ...mapState('Notification', {
      reminders: state => state.importantReminders.waterCrossingReminders,
    }),
    ...mapGetters('Notification', ['isLUPCTown']),
  },
};
</script>
